import { render, staticRenderFns } from "./model-noData.vue?vue&type=template&id=27392ea8&scoped=true&"
import script from "./model-noData.vue?vue&type=script&lang=js&"
export * from "./model-noData.vue?vue&type=script&lang=js&"
import style0 from "./model-noData.vue?vue&type=style&index=0&id=27392ea8&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27392ea8",
  null
  
)

export default component.exports